var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_vm._m(0),(_vm.data)?_c('Echart',{staticStyle:{"margin-top":"-100px"},attrs:{"options":_vm.chartOption,"id":"productMonthChart","width":"100%","height":"730px"}}):_vm._e()],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-line",staticStyle:{"position":"relative"}},[_c('div',{staticClass:"title1"},[_vm._v("产量/种植面积")])])
}]

export { render, staticRenderFns }